import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  inject, computed
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators, FormBuilder } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Services } from "src/app/services/api.service"
import { GlobalConstants } from 'src/app/common/global';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective } from 'ngx-mask';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { OrderService } from 'src/app/services/getOrder.service';
import { Order, OrderItem, ProfileField } from 'src/app/common/event.model';
import {takeUntilDestroyed, toSignal} from '@angular/core/rxjs-interop';
import {
  atLeastOneLetterValidator,
  dateValidator,
  duplicateBarcodeValidator,
  oibValidator,
  strictEmailValidator,
  parseWithGoogleLibphonenumber,
  applyCountryOibIdLogicValidation
} from 'src/app/utils/validators';
import {
  BarcodeResponseData,
  GuestData,
  MemberData,
  MemberMissingData,
  SubscriberData,
  UserProfile
} from 'src/app/common/interfaces';
import { CartInfoBoxComponent } from '../cart-info-box/cart-info-box.component';
import {debounceTime, distinctUntilChanged, map} from 'rxjs';
import { trimAllControls } from 'src/app/utils/trim-values.util';
import { ProfileService } from 'src/app/services/profile.service';
import { DeliveryComponent } from '../delivery/delivery.component';
import { AppConfigService } from 'src/app/common/app-config/app-config.service';
import { AppConfig } from 'src/app/common/app-config/app-config.interface';
import {GetUserProfileService} from "../../services/getUserProfile.service";

@Component({
  selector: 'app-users-form-fields',
  templateUrl:  `${environment.pageFolder}/users-form-fields.${environment.pageFolder}.component.html`,
  styleUrls: [`${environment.pageFolder}/users-form-fields.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, NgxMaskDirective, CartInfoBoxComponent, DeliveryComponent]
})

export class UsersFormFieldsComponent implements OnInit, OnChanges {
  @Input() showPayment: any;
  @Input() event: any;
  @Input() hasPayment: any;
  @Output() changeShowPaymentEvent = new EventEmitter<boolean>();
  @Output() emptyCartEvent = new EventEmitter<any>();
  @Input() cardType:string = "";
  @Input() customerProfile: any;
  @Input() eventProfileType: any;
  @Input() isEventMembersExlusive: any;
  @Input() connId:any = environment.connId;
  @Input() orderId!: number;
  @Input() formFieldsKey: number | undefined;
  buyMembership: boolean = false;
  hideButtons: boolean = false;
  hideContinueButton: boolean = false;
  errorMessage: string = "";
  errorDuplicatesMessage: string = "";
  showSuccessMessage: boolean = false;
  redirectUrl = environment.redirectUrl;
  userProfileForm!: FormGroup;
  userProfileTypeList: ProfileField[] = [];
  loader = document.getElementById("loader-container");
  membersExclusive: boolean = false;
  membershipErrorMessage: string = "";
  cart!: Order;
  showInputForMembershipBarcode: boolean[] = [];
  membersData: MemberData[] = [];
  oibErrorMessage: string = "";
  eventId: any;
  barcodeType: string = "Barkod iskaznice";
  hasAllEnteredValues: boolean = false;
  membershipBarcode: string = '';
  appConfig: AppConfig;
  userEmail: string = '';

  showDelivery: boolean = false;
  initialCall: boolean = true;
  showDeliverySubscriptionWithMember: boolean = false;
  deliverySubscription: any = null;
  deliveryForm: FormGroup = this.formBuilder.group({
    deliverySameAs: [true]
  });

  keyMapping: any = {
    ime: 'firstName',
    prezime: 'lastName',
    dat_rodj: 'birthDate',
    adresa: 'adresa',
    email: 'email',
    id: "ID",
    tel: "TEL"
  };

  lovItemsMap: Record<string, { key: string; value: string }[]> = {};
  private lovValueToKeyIndex: Record<string, Map<string, string>> = {};

  private readonly connKeyMapping: Record<string, string> = {
    ime: 'firstName',
    prezime: 'lastName',
    oib_osobe: 'oib',
    dat_rodj: 'dateOfBirth',
    email: 'email',
    tel: 'phone',
    mjesto: 'city',
    pbr: 'postCode',
    kucni_broj: 'houseNo',
    adresa: 'address',
    spol: 'gender',
    drzavljanstvo: 'country'
  };

  public prefillSelectedItemId: number | null = null;
  readonly userProfileService = inject(GetUserProfileService);
  readonly userProfileSignal = toSignal<UserProfile | null>(
    this.userProfileService.getConnectionUserProfile().pipe(map(response => response.data)),
    { initialValue: null }
  );
  readonly hasUserProfile = computed(() => !!this.userProfileSignal());

  seasonTicketExclusive: boolean = false;

  constructor(
    private readonly http: HttpClient,
    public Services: Services,
    private readonly errorMessageService: ErrorMessageService,
    private readonly orderService: OrderService,
    private readonly destroyRef: DestroyRef,
    private profileService: ProfileService,
    private formBuilder: FormBuilder,
    private appConfigService: AppConfigService,
  ) {
    this.seasonTicketExclusive = false;
    this.appConfig = this.appConfigService.getConfig();
  }

  ngOnInit(): void {
    this.eventId = this.event.event.id;

    if(environment.pageFolder === 'sport' && this.event) {
      this.isEventMembersExlusive = this.event.action.membersExclusive;
      this.eventProfileType = this.event.event.profileType;
    }

    if(this.isEventMembersExlusive) {
      this.getMemberships();
    }

    this.getCartData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formFieldsKey'] && !changes['formFieldsKey'].firstChange) {
      this.getCartData();
    }
  }

  getCartData(refresh: boolean = false): void {
    this.loader!.style.display = "flex";
    this.errorMessage = '';

    let existingValuesByItemId: Record<number, Record<string, any>> = {};
    if (this.userProfileForm) {
      const itemsArray = this.userProfileForm.get("items") as FormArray;
      this.cart.items.forEach((item: OrderItem, index: number) => {
        const group = itemsArray.at(index) as FormGroup;
        if (group && item.id != null) {
          existingValuesByItemId[item.id] = group.getRawValue();
        }
      });
    }

    this.orderService.getOrder(this.orderId, refresh).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (order) => {
        this.cart = order;
        this.showInputForMembershipBarcode = Array(this.cart.items.length).fill(false);
        this.userProfileTypeList = order.items.flatMap(item => item.profile.fields);

        this.buildLovMapsFromFields(this.userProfileTypeList);
        if (this.prefillSelectedItemId != null) {
          const stillExists = order.items.some(item => item.id === this.prefillSelectedItemId);
          if (!stillExists) {
            this.prefillSelectedItemId = null;
          }
        }

        if((this.event.action.membersExclusive || this.isEventMembersExlusive) && this.event.event.isGroup && !this.cart.transactionInfo.deliveryDataSubmitted) {
          this.callDeliverySubscription();
        }

        let fieldIndex = 0;
        const groups = order.items.map(item => {
          const controls: Record<string, FormControl<string|null>> = {};

          item.profile.fields.forEach((field: ProfileField) => {
            if(!field.visible) {
              return;
            }

            const validators = [];

            if (field.mandatory) {
              validators.push(Validators.required);
            }
            if (field.length) {
              validators.push(Validators.maxLength(field.length));
            }

            if (field.name === 'email') {
              validators.push(strictEmailValidator);
            } else if (field.name === 'oib_osobe') {
              validators.push(oibValidator, Validators.maxLength(field.length));
            } else if (field.name === 'dat_rodj') {
              validators.push(dateValidator);
            } else if (field.name === 'ime' || field.name === 'prezime') {
              validators.push(atLeastOneLetterValidator());
            }

            const initial = field.lovItems?.length ? field.lovItems[0].key : field.value ?? '';
            const control = new FormControl(
              { value: initial, disabled: !field.changeable },
              { validators, nonNullable: false }
            );

            if (field.name === 'drzavljanstvo') {
              setTimeout(() => {
                const selectElements = document.querySelectorAll('[name="drzavljanstvo"]');
                fieldIndex++;
                selectElements.forEach((element, index) => {
                  if((index+1) !== fieldIndex) {
                    return;
                  }

                  const selectElement = element as HTMLSelectElement;
                  selectElement.value = field.value || 'HR';
                  this.cart.items[index].selectedCountryId = field.value || 'HR';
                  const group = (this.userProfileForm.get('items') as FormArray).at(index) as FormGroup;
                  group.get('drzavljanstvo')?.setValue(field.value || 'HR');
                });
              }, 0);
            } else if (field.name === 'phoneNo') {
              validators.push(parseWithGoogleLibphonenumber(control));
            }

            Object.assign(control, {
              type: field.type.toLowerCase(),
              id: field.id,
              name: field.name,
              value: field.value,
            });
            controls[field.name] = control;
          });

          controls['membershipBarcode'] = new FormControl<string | null>(null, { validators: [], nonNullable: false });
          const group = new FormGroup(controls);

          applyCountryOibIdLogicValidation(group, item.profile.fields, this.destroyRef);

          return group;
        });

        this.userProfileForm = new FormGroup({
          items: new FormArray(groups, {validators: [duplicateBarcodeValidator(() => this.membersExclusive)]}),
          termsOfSale: new FormControl<boolean>(false, { validators: [Validators.requiredTrue], nonNullable: true })
        });

        if(!this.hasPayment) {
          this.changeShowPayment(false);
        }

        if(this.event.action.membersExclusive || this.isEventMembersExlusive) {
          this.membersExclusive = true;
        }

        this.subscribeToMembershipBarcodeChanges();

        setTimeout(() => {
          let usersData = this.cart.items;
          this.prefillData(usersData);

          const itemsArray = this.userProfileForm.get('items') as FormArray;
            this.cart.items.forEach((item: OrderItem, index: number) => {
              const savedGroup = existingValuesByItemId[item.id];
              if (!savedGroup) {
                return;
              }
              const group = itemsArray.at(index) as FormGroup;
              if (!group) {
                return;
              }
              Object.keys(savedGroup).forEach((fieldName) => {
                const control = group.get(fieldName);
                if (!control) {
                  return;
                }

                control.setValue(savedGroup[fieldName], { emitEvent: false });
                if (fieldName === 'membershipBarcode' && savedGroup[fieldName]) {
                  this.toggleMembershipInput(true, index);
                }
              });
            });
        }, 0);

        if(this.seasonTicketExclusive) {
          setTimeout(() => {
            this.cart.items.forEach((item: any, index: number) => {
              this.toggleMembershipInput(true, index);
            });
          }, 200);
        }

        this.loader!.style.display = "none";
      },
      error: () => {
        this.loader!.style.display = "none";
      }
    });
  }

  updateFields() {
    this.changeShowPayment(false);
    this.showPayment = false;
  }

  onSubmitNew() {
    const itemsArray = this.userProfileForm.get('items') as FormArray;

    if (!this.appConfig.appHasMembership) {
      itemsArray.controls.forEach(control => {
        const c = (control as FormGroup).get('membershipBarcode');
        c?.disable({ emitEvent: false });
        c?.clearValidators();
        c?.setErrors(null);
        c?.updateValueAndValidity({ emitEvent: false });
      });
    }

    if (this.appConfig.appHasMembership) {
      let missingBarcode = false;
      itemsArray.controls.forEach((group, index) => {
        if (this.showInputForMembershipBarcode[index] || this.isEventMembersExlusive) {
          const barcodeControl = group.get('membershipBarcode')!;
          if (!barcodeControl.value) {
            barcodeControl.setErrors({ barcodeRequired: true });
            barcodeControl.markAsTouched();
            missingBarcode = true;
          }
        }
      });
      if (missingBarcode) {
        this.errorMessage = this.errorMessageService.getErrorMessage('barcodeRequired');
        return;
      }

      itemsArray.controls.forEach((group, index) => {
        if (!this.showInputForMembershipBarcode[index]) return;

        const barcodeControl = (group as FormGroup).get('membershipBarcode')!;
        this.Services
          .checkBarcodeService(barcodeControl.value, false)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: response => {
              if (!response.data.isValid) {
                barcodeControl.setErrors({ invalid: true });
                barcodeControl.markAsTouched();
                this.errorMessage = this.errorMessageService.getErrorMessage('invalidBarcode');
              }
            }
          });
      });

      if (this.isEventMembersExlusive) {
        itemsArray.controls.forEach(control => {
          const group = control as FormGroup;
          Object.keys(group.controls).forEach(controlName => {
            if (controlName !== 'membershipBarcode') {
              group.removeControl(controlName);
            }
          });
        });
      }
    }

    trimAllControls(this.userProfileForm);

    if (this.userProfileForm.invalid) {
      this.userProfileForm.markAllAsTouched();

      const missingRequired = itemsArray.controls.some(group => Object.values((group as FormGroup).controls).some(control => control.hasError('required')));
      const invalidDate = itemsArray.controls.some(group => Object.values((group as FormGroup).controls).some(control => control.hasError('invalidDate')));
      const invalidOIB = itemsArray.controls.some(group => Object.values((group as FormGroup).controls).some(control => control.hasError('invalidOib')));
      const noLetters = itemsArray.controls.some(group => Object.values((group as FormGroup).controls).some(control => control.hasError('noLetter')));

      if (this.userProfileForm.get('termsOfSale')!.invalid) {
        this.errorMessage = this.errorMessageService.getErrorMessage('termsOfSaleRequired');
      } else if (itemsArray.hasError('duplicateBarcode')) {
        this.errorMessage = this.errorMessageService.getErrorMessage('membershipInvalidBarcode');
      } else if (missingRequired) {
        this.errorMessage = this.errorMessageService.getErrorMessage('allFieldsRequired');
      } else if (invalidDate) {
        this.errorMessage = this.errorMessageService.getErrorMessage('invalidDate');
      } else if (invalidOIB) {
        this.errorMessage = this.errorMessageService.getErrorMessage('invalidOIB');
      } else if (noLetters) {
        this.errorMessage = this.errorMessageService.getErrorMessage('noLetters');
      } else {
        this.errorMessage = this.errorMessageService.getErrorMessage('error');
      }

      return;
    }

    let inputs = document.querySelectorAll('[data-name="user-data"]');

    if(!this.membersExclusive) {
      const itemGroups = itemsArray.controls as FormGroup[];
      const isSpecialEvent = [2800, 2949].includes(this.eventId);

      const subscribersData: SubscriberData[] = itemGroups.flatMap((group, index) => {
        const barcodeControl = group.get('membershipBarcode')!.value;
        if (!barcodeControl || !this.seasonTicketExclusive) return [];

        const fields = this.userProfileTypeList.reduce((acc, field) => {
          acc[field.name] = group.get(field.name)!.value ?? '';
          return acc;
        }, {} as Record<string,string>);

        return [{
          itemId: this.cart.items[index].id,
          profileType: this.eventProfileType,
          barcode: barcodeControl.toString(),
          fields
        }];
      });

      const membersThatHasAllData: Array<{ barcode: string; itemId: number }> = itemGroups.flatMap((group, index) => {
        const barcodeControl = group.get('membershipBarcode')!.value;
        if (!barcodeControl) return [];

        if (!this.seasonTicketExclusive || isSpecialEvent) {
          return [{
            barcode: barcodeControl.toString(),
            itemId: this.cart.items[index].id
          }];
        }

        return [];
      });

      const membersThatDoesntHaveAllData: MemberMissingData[] = itemGroups.flatMap((group, index) => {
        const barcodeControl = group.get('membershipBarcode')!.value;
        if (!barcodeControl) return [];

        const missingFields = this.userProfileTypeList
          .filter(field => {
            const value = group.get(field.name)!.value;
            return value !== null && value !== undefined && value !== '';
          })
          .reduce((acc, field) => {
            acc[field.name] = group.get(field.name)!.value ?? '';
            return acc;
          }, {} as Record<string,string>);

        if (Object.keys(missingFields).length > 0 && (!this.seasonTicketExclusive || isSpecialEvent)) {
          const memberRecord = this.membersData.find(m => m.cartItemId === this.cart.items[index].id)!;

          return [{
            profileId: memberRecord.id,
            profileType: memberRecord.profileType,
            fields: missingFields
          }];
        }

        return [];
      });

      const guests: GuestData[] = this.seasonTicketExclusive ? [] : itemGroups.flatMap((group, index) => {
        const barcodeControl = group.get('membershipBarcode')!.value;
        if (barcodeControl) return [];

        const drzavljanstvo = group.get('drzavljanstvo')?.value || group.get('drzava_lov')?.value;
        let filteredFields = this.userProfileTypeList.filter(field => {
          if (field.name === 'id' && drzavljanstvo === 'HR') {
            return false;
          }
          if (field.name === 'oib_osobe' && drzavljanstvo !== 'HR') {
            return false;
          }
          return true;
        });

        const fields = filteredFields.reduce((acc, field) => {
          acc[field?.name] = group.get(field?.name)?.value ?? '';
          return acc;
        }, {} as Record<string, string>);

        return [{
          itemId: this.cart.items[index].id,
          profileType: this.eventProfileType ?? 'GOST',
          fields
        }];
      });

      const duplicateMessages = this.getDuplicateGuestMessages(guests);
      if (duplicateMessages.length > 0) {
        this.errorDuplicatesMessage = this.errorMessageService.getErrorMessage('multipleSamePerson') + ' ' + duplicateMessages.join('; ');
        return;
      }

      const body = {
        updateProfiles: membersThatDoesntHaveAllData,
        members: membersThatHasAllData,
        guests,
        newProfiles: (isSpecialEvent) ? [] : subscribersData
      };

      this.loader!.style.display = "flex";

      this.Services.updateMembersProfileService(body, this.orderId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: data => {
          let response:any = data;
          //this.loader!.style.display = "none";

          let error = false;
          const combined = [...(response.data.guests ?? []), ...(response.data.members ?? [])];

          combined.forEach((item: { message: string; itemId: string; status: boolean; }) => {
            if (item.status === false) {
              let inputs = document.querySelectorAll('[data-name="user-data"]');
              let sbr = Number(item.itemId);
              error = true;
              inputs.forEach((inputItem:any) => {
                let itemSbr = Number(inputItem.getAttribute("data-sbr"));
                if(itemSbr === sbr) {
                  if((environment.connId === "9" || environment.connId === "1009")) {
                    let inputIsInMemberData = this.membersData.find(member => member.cartItemId === sbr);

                    if((inputIsInMemberData && this.membersData.length > 0) || this.membersData.length === 0) {
                      inputItem.disabled = false;
                      inputItem.parentElement.classList.remove("disabled");
                    }
                  }
                  ((environment.connId === "9" || environment.connId === "1009")) && (inputItem.nextElementSibling.style.width = "100%");
                  if(item.message === "ima_ulaznicu" || item.message === "ima_ulaznice") {
                    this.errorMessage = this.errorMessageService.getErrorMessage('alreadyHasTicket');
                  } else if(item.message === "blacklist") {
                    this.errorMessage = this.errorMessageService.getErrorMessage('contactClubForThisUser');
                  } else if(item.message === "nepostojeca_clanska") {
                    this.errorMessage = this.errorMessageService.getErrorMessage('membershipNotFound');
                  } else if(item.message === "vlasnici_se_ne_podudaraju") {
                    this.errorMessage = this.errorMessageService.getErrorMessage('membershipDataNotMatch');
                  } else if(item.message === "iskoristena_clanska") {
                    this.errorMessage = this.errorMessageService.getErrorMessage('membershipAlreadyUsed');
                  } else if(item.message === "neuspjela_primjena_popusta") {
                    this.errorMessage = this.errorMessageService.getErrorMessage('membershipDiscountFailed');
                  } else if(item.message === "ima_godisnju") {
                    this.errorMessage = this.errorMessageService.getErrorMessage('membershipHasAnnualTicket');
                  } else {
                    this.errorMessage = this.errorMessageService.getErrorMessage('userError');
                  }

                  if((environment.connId === "9" || environment.connId === "1009")) {
                    inputItem.nextElementSibling.style.setProperty("background-color", "#ed0000", "important");
                  }
                }
              });
            }
          });

          if(!error) {
            this.orderService.getOrder(this.orderId, true).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
              next: (order) => {
                if (!this.cart) {
                  this.cart = order;
                }

                order.items.forEach((updatedItem: OrderItem) => {
                  const existingItem = this.cart.items.find((item: OrderItem) => item.id === updatedItem.id);
                  if (existingItem) {
                    existingItem.price = updatedItem.price;
                    existingItem.currency = updatedItem.currency;
                  }
                });

                this.cart.totalPrice = order.totalPrice;
                this.cart.additionalItems = order.additionalItems;
              }
            });
          }

          this.loader!.style.display = "none";

          if(!error) {
            this.changeShowPayment(true);
            this.hideContinueButton = true;
            this.errorMessage = "";

            setTimeout(() => {
              document.getElementById("order-payment")?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 200);
          }
        }, error: error => {
          this.loader!.style.display = "none";
          if (error.error.errors[0].code === "ORA-20131") {
            this.errorMessage = this.errorMessageService.getErrorMessage('discountChangeFailed');
          } else {
            this.errorMessage = this.errorMessageService.getErrorMessage('error');
          }
        }
      })
    } else if(this.membersExclusive) {
      if (!this.cart) {
        return;
      }

      let membershipIdList:any = [];
      let membershipErrorMessageFields = document.querySelectorAll('[data-name="membership-error-message"]');

      inputs.forEach((item:any, index:number) => {
        membershipIdList.push(
          {
            "itemId": this.cart.items[index].id,
            "barcode": item.value.toString().trim()
        });
      })

      this.loader!.style.display = "flex";
      this.http.post(`${environment.apiUrl}/conn/${this.connId}/v1/orders/${this.orderId}/members`, membershipIdList, GlobalConstants.headersCentral).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: data => {
          let response:any = data;
          let error: boolean = false;

          response.data.map((item:any, index: number) => {
            let errorMessage:any = membershipErrorMessageFields[index];

            if(item.status === false) {
              let inputItem:any = inputs[index].nextElementSibling;
              error = true;
              if(item.message === "nepostojeci") {
                errorMessage.innerHTML = this.errorMessageService.getErrorMessage('membershipNotFoundWithBarcode');
              } else if (item.message === "blacklist") {
                errorMessage.innerHTML = this.errorMessageService.getErrorMessage('membershipContactClub');
              } else if (item.message === "ima_ulaznice") {
                errorMessage.innerHTML = this.errorMessageService.getErrorMessage('membershipAlreadyHasTicket');
              } else if(item.message === "iskoristeni") {
                errorMessage.innerHTML = this.errorMessageService.getErrorMessage('membershipMaxFreeTickets');
              } else if(item.message === "ima_godisnju") {
                errorMessage.innerHTML = this.errorMessageService.getErrorMessage('membershipHasAnnualTicketWithBarcode');
              }

              this.errorMessage = this.errorMessageService.getErrorMessage('membershipInvalidBarcode');
              (environment.configId === "1") && inputItem.style.setProperty("background-color", "#ed0000", "important");
              errorMessage.style.setProperty("display", "block");
            } else {
              errorMessage.innerHTML = "";
              errorMessage.style.setProperty("display", "none");
            }
          })

          if(error === false) {
            this.hideContinueButton = true;
            this.errorMessage = "";

            if(!this.hasPayment) {
              this.getTicket();
            } else {
              this.getCartData(true);
              this.changeShowPayment(true);
              setTimeout(() => {
                document.getElementById("order-payment")?.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }, 200);
            }
          } else {
            this.loader!.style.display = "none";
          }
        }, error: error => {
          if(error.status === 401) {
            this.Services.logout();
          }
          this.loader!.style.display = "none";
          this.errorMessage = this.errorMessageService.getErrorMessage('error');
        }
      })
    }
  }

  prefillData(usersData: OrderItem[]) {
    let allMandatoryDataEntered = true;
    const itemsArray = this.userProfileForm.get('items') as FormArray;

    usersData.forEach((item, index) => {
      const group = itemsArray.at(index) as FormGroup;

      const countryControl = group.get('drzava_lov');
      if (countryControl && (countryControl.value === null || countryControl.value === '')) {
        countryControl.setValue('HR');
      }

      if (item.discount && !this.isEventMembersExlusive) {
        this.toggleMembershipInput(true, index);

        const barcodeValue = item.discount.justification.membersBarcode;
        group.get('membershipBarcode')!.setValue(barcodeValue);

        this.checkMemberBarcode(index);
      } else if(!this.isEventMembersExlusive) {
        item.profile.fields.forEach(field => {
          if (field.value) {
            group.get(field.name)!.setValue(field.value);
          }
        });

        item.profile.fields
          .filter(field => field.mandatory && field.visible)
          .forEach(field => {
            const fieldValue = group.get(field.name)!.value;
            if (!fieldValue?.toString().trim()) {
              allMandatoryDataEntered = false;
            }
          });
      } else if (this.isEventMembersExlusive) {
        this.toggleMembershipInput(true, index);
        const barcodeValue = item.discount?.justification?.membersBarcode || '';
        group.get('membershipBarcode')!.setValue(barcodeValue);

        if (barcodeValue) {
          this.checkMemberBarcode(index);
        } else {
          allMandatoryDataEntered = false;
          this.showDelivery = false;
        }
      }
    });

    if (allMandatoryDataEntered) {
      this.changeShowPayment(true);
      this.hideContinueButton = true;
      this.userProfileForm.get('termsOfSale')!.setValue(true);
    } else {
      this.showDelivery = false;
    }
  }

  changeShowPayment(value: boolean) {
    if((((this.event.action.membersExclusive || this.isEventMembersExlusive) && this.event.event.isGroup) || (!this.deliveryForm.get('deliverySameAs')?.value && this.showDeliverySubscriptionWithMember) && this.hideContinueButton) && value && !this.cart.transactionInfo.deliveryDataSubmitted) {
      this.showDelivery = true;
    } else {
      this.showPayment = value;
      this.showDelivery = false;
      this.changeShowPaymentEvent.emit(value);
    }
  }

  cancelOrder() {
    if (!this.cart) {
      return;
    }

    localStorage.removeItem("orderInfo");

    if((this.cart.items.length > 0 && (this.cardType === "kekspay" || this.cardType === "aircashpay")) || this.cart.items.length === 0) {
      document.location = this.redirectUrl;
    } else {
      let newUrl = {
        changeUrl: false,
        url: ""
      }

      this.Services.cancelOrder(this.orderId, false, newUrl);
    }
  }

  checkValue(event: any){
    if(event.target.checked) {
      (environment.connId === "9" || environment.connId === "1009") && (event.target.nextElementSibling.style.backgroundColor = "#012641c4");
      environment.configId === "2" && (event.target.nextElementSibling.style.borderColor = "#D3D3D3");
      this.errorMessage = "";
    } else {
      (environment.connId === "9" || environment.connId === "100") && (event.target.nextElementSibling.style.backgroundColor = "#e6e6e6");
    }
  }

  getTicket() {
    window.localStorage.removeItem('orderId');
    window.localStorage.removeItem('orderIdEventId');
    this.http.get(`${environment.apiUrl}/v1/public/order/${this.connId}/${this.orderId}/commit`,  GlobalConstants.headersCentral).subscribe({
      next: data => {
        this.loader!.style.display = "none";
        let response:any = data;
        this.hideButtons = true;

        if(response.success === true) {
          this.showSuccessMessage = true;
        } else {
          this.errorMessage = this.errorMessageService.getErrorMessage('errorTryAgain');
        }
    }})
  }

  clearProfileFields(itemIndex: number){
    const itemsArray = this.userProfileForm.get('items') as FormArray;
    const group = itemsArray.at(itemIndex) as FormGroup;

    Object.keys(group.controls).forEach(controlName => {
      if (controlName === 'membershipBarcode' || controlName === 'drzava_lov') {
        return;
      }

      const control = group.get(controlName)!;
      control.reset();
      control.setErrors(null);
      control.enable();
    });
  }

  checkHavingMembership(event: Event, index: number) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) {
      return;
    }
    this.toggleMembershipInput(target.checked, index);
  }

  toggleMembershipInput(isChecked: boolean, index: number) {
    this.showInputForMembershipBarcode[index] = isChecked && !this.membersExclusive;

    if (!isChecked) {
      const array = this.userProfileForm.get('items') as FormArray;
      const group = array.at(index) as FormGroup;
      const barcodeControl = group.get('membershipBarcode')!;

      barcodeControl.reset();
      this.clearProfileFields(index);
    }
  }

  onBarcodeInputImmediate(event: Event, itemIndex: number): void {
    this.limitInputLengthForNumberic(event);
    this.clearProfileFields(itemIndex);

    const inputELement = event.target as HTMLInputElement;
    const value = inputELement.value.replace(/\D/g, '');
    if (value.length === 12) {
      const itemsArray = this.userProfileForm.get('items') as FormArray;
      const group = itemsArray.at(itemIndex) as FormGroup;
      group.get('membershipBarcode')!.markAsTouched();
      this.checkMemberBarcode(itemIndex);
    }
  }

  private subscribeToMembershipBarcodeChanges(): void {
    const itemsArray = this.userProfileForm.get('items') as FormArray;

    this.cart.items.forEach((_item, index) => {
      const group = itemsArray.at(index) as FormGroup;
      const barcodeControl = group.get('membershipBarcode')!;

      barcodeControl.setValidators(barcodeControl.validator);
      barcodeControl.valueChanges
        .pipe(
          distinctUntilChanged(),
          debounceTime(2000),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe(inputedValue => {
          let filteredValue = (inputedValue ?? '').toString().replace(/\D/g, '');
          if (filteredValue.length === 12) {
            return;
          }

          if (filteredValue.length > 12) {
            filteredValue = filteredValue.slice(0, 12);
            barcodeControl.setValue(filteredValue, { emitEvent: false });
          }

          if (filteredValue.length > 0) {
            barcodeControl.markAsTouched();
            this.checkMemberBarcode(index);
          }
        });
    });
  }

  checkMemberBarcode(itemIndex: number) {
    const array = this.userProfileForm.get('items') as FormArray;
    const group = array.at(itemIndex) as FormGroup;
    const barcodeControl = group.get('membershipBarcode')!;
    let cartItemId = this.cart.items[itemIndex].id;

    barcodeControl.markAsTouched();
    const inputedBarcodeValue = barcodeControl.value?.toString().trim();

    if (!inputedBarcodeValue) {
      barcodeControl.setErrors({ required: true });
      return;
    }

    this.loader!.style.display = 'flex';
    barcodeControl.setErrors(null);

    this.Services.checkBarcodeService(inputedBarcodeValue, false).subscribe({
      next: (response: { success: boolean; data: BarcodeResponseData }) => {
        this.loader!.style.display = 'none';
        const res = response.data;

        if (!res.isValid) {
          barcodeControl.setErrors({ invalidBarcode: true });
          return;
        }

        barcodeControl.setErrors(null);

        this.membersData = this.membersData.filter(m => m.cartItemId !== cartItemId);
        res.cartItemId = cartItemId;
        this.membersData.push(res);

        this.userProfileTypeList.forEach(field => {
          const key = this.keyMapping[field.name];
          const control = group.get(field.name)!;
          if (key in res) {
            control.setValue((res as any)[key]);
            control.disable();
          } else {
            control.enable();
          }
        });
      },
      error: () => {
        this.loader!.style.display = "none";
        this.errorMessage = this.errorMessageService.getErrorMessage('error');
      },
    });
  }

  onClickInputField() {
    if(this.showPayment === true) {
      this.hideContinueButton = false;
      this.changeShowPayment(false);
    }

    this.errorDuplicatesMessage = "";
  }

  private getDuplicateGuestMessages(guests: GuestData[]): string[] {
    const groups = new Map<string, number[]>();

    guests.forEach((guest, index) => {
      const key = JSON.stringify(guest.fields);
      const array = groups.get(key);
      if (array) {
        array.push(index + 1);
      } else {
        groups.set(key, [index + 1]);
      }
    });

    return Array.from(groups.values()).filter(indices => indices.length > 1)
      .map(indices => this.errorMessageService.getErrorMessage('ticketsUsers') + ' ' + indices.join(', '));
  }

  getMemberships() {
    this.profileService.getMemberships(true).subscribe({
      next: (data) => {
        const response: any = data;
        response.data?.own?.isActive && (this.membershipBarcode = response.data.own?.barcode);
      }}
    );
  }

  limitInputLengthForNumberic(event: Event): void {
    const inputEl = event.target as HTMLInputElement;
    let inputValue = inputEl.value.replace(/\D/g, '');
    if (inputValue.length > 12) {
      inputValue= inputValue.slice(0, 12);
    }
    inputEl.value = inputValue;
  }

  removeItemFromOrder(cartItemId: number): void {
    this.loader!.style.display = "flex";
    this.Services.removeItemFromOrder(this.orderId, cartItemId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        if(this.cart.items.length === 1) {
          //this.emptyCartEvent.emit();
          window.location.reload();
        } else {
          this.getCartData(true);
        }
        this.loader!.style.display = "none";
      },
      error: () => {
        this.loader!.style.display = "none";
        this.errorMessage = this.errorMessageService.getErrorMessage('error');
      }
    });
  }

  prefillDataForProfileOwner(event: Event, inputId: string) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const itemsArray = this.userProfileForm.get('items') as FormArray;
    const firstGroup = itemsArray.at(0) as FormGroup;
    const barcodeControl = firstGroup?.get('membershipBarcode');
    if (!barcodeControl) return;
    barcodeControl.setValue(isChecked ? this.membershipBarcode : null);
  }

  callDeliverySubscription() {
    this.Services.deliverySubscriptionWithMember(Number(this.orderId)).subscribe({
      next: (data: any) => {
        if(data.data.deliveryData.length > 0) {
          this.showDeliverySubscriptionWithMember = true;
          this.deliverySubscription = data.data;

          this.showPayment = true;

          if(this.initialCall) {
            this.initialCall = false;
            this.setDeliveryWay();
          }
        } else if(this.showPayment) {
          if(!this.cart.transactionInfo.deliveryDataSubmitted) {
            this.showDelivery = true;
            this.showPayment = false;
          } else {
            this.showPayment = true;
            this.showDelivery = false;
          }
        }
      }
    });
  }

  setDeliveryWay() {
    const isChecked = this.deliveryForm.get('deliverySameAs')?.value;

    if (isChecked) {
      let body = {
        'deliveryId': "W01_1",
        'deliveryData': {
          "email": "",
          "ime": "",
          "prezime": "",
          "adresa": "",
          "kucni_broj": "",
          "mjesto": "",
          "pbr": "",
          "drzava": "",
          "tel": "",
          "napomena": "",
        }
      }

      body.deliveryId = this.deliverySubscription.deliveryData[0].sifra;
      body.deliveryData.napomena = this.deliverySubscription.deliveryData[0].napomena;

      this.http.post(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${this.orderId}/delivery`, body, GlobalConstants.headersCentral).subscribe({
        next: () => {
          this.getCartData(true);
        }
      });
    } else {
      this.http.delete(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${this.orderId}/delivery`, GlobalConstants.headersCentral).subscribe({
        next: () => {
          this.getCartData(true);
        }
      });
    }
  }

  emitOnSubmitDeliveryData() {
    this.getCartData(true);
    this.changeShowPaymentEvent.emit(true);
    this.showDelivery = false;
    this.showPayment = true;
  }

  onCountryChange(event: Event, user: any): void {
    const selectElement = event.target as HTMLSelectElement;
    user.selectedCountryId = selectElement.value;

    if (user.selectedCountryId !== 'HR') {
      setTimeout(() => {
        const inputElement = document.querySelector(`input[data-fieldNameWithCartId="oib_osobe-${user.id}"]`) as HTMLInputElement;
        if (inputElement) {
          inputElement.value = "";
          inputElement.dispatchEvent(new Event("input"));
          //put mandatory as false on that control
        }
      }, 0);
    } else {
      setTimeout(() => {
        const inputElementId = document.querySelector(`input[data-fieldNameWithCartId="id-${user.id}"]`) as HTMLInputElement;
        if (inputElementId) {
          inputElementId.value = "";
          inputElementId.dispatchEvent(new Event("input"));
        }
      }, 0);
    }
  }

  onPrefillProfileData(itemId: number, event: Event) {
    const checked = (event.target as HTMLInputElement).checked;

    const index = this.cart.items.findIndex(item => item.id === itemId);
    if (index === -1) {
      return;
    }

    const profile = this.userProfileSignal();
    if (!profile) {
      return;
    }

    const itemsArray = this.userProfileForm.get('items') as FormArray;
    const group = itemsArray.at(index) as FormGroup;
    if (!group) {
      return;
    }

    this.prefillSelectedItemId = checked ? itemId : null;

    if (checked) {
      const patch: Record<string, any> = {};
      Object.keys(group.controls).forEach(controlName => {
        if (controlName === 'membershipBarcode') {
          return;
        }

        // Specific logic for ID since ID as in name of the field is not the same as ID from profile endpoint
        if (controlName === 'id') {
          const current = group.get(controlName)?.value;
          if (current !== null && current !== undefined && String(current) !== '') {
            patch[controlName] = '';
          }
          return;
        }

        if (!(controlName in this.connKeyMapping)) return;
        const profileKey = this.connKeyMapping[controlName];
        const value = (profile as any)[profileKey];

        if (value !== undefined) {
          if (this.lovItemsMap[controlName]) {
            const index = this.lovValueToKeyIndex[controlName];
            patch[controlName] = index?.get(String(value)) ?? (value ?? '');
          } else {
            patch[controlName] = value ?? '';
          }
        }
      });

      group.patchValue(patch);
      Object.keys(patch).forEach(controlName => {
        const control = group.get(controlName);
        control?.markAsDirty();
        control?.updateValueAndValidity();
      });

    } else {
      Object.keys(group.controls).forEach(controlName => {
        if (controlName === 'membershipBarcode') {
          return;
        }

        const control = group.get(controlName);
        if (!control) return;
        control.setValue('', { emitEvent: false });
      });
    }
  }

  private buildLovMapsFromFields(fields: ProfileField[]): void {
    const lovItemsMap: Record<string, { key: string; value: string }[]> = {};
    const valueToKeyIndex: Record<string, Map<string, string>> = {};

    fields.forEach(field => {
      if (!field.lovItems?.length) {
        return;
      }

      lovItemsMap[field.name] = field.lovItems;

      const index = new Map<string, string>();
      field.lovItems.forEach(({ key, value }) => {
        index.set(value, key);
        index.set(key, key);
      });
      valueToKeyIndex[field.name] = index;
    });

    this.lovItemsMap = lovItemsMap;
    this.lovValueToKeyIndex = valueToKeyIndex;
  }
}
